"use client";

import styles from './_balance.module.scss';
import CustomImage from '@/components/image';

export default function HcpCahOverviewBalance() {
  return (
    <section className={styles.balance}>
      <div className={`container ${styles.container}`}>
        <h1 className="page-heading">Balance is often elusive when treating with GCs alone<sup>3,4</sup></h1>
        <div className={`${styles.data} ${styles.data1}`}>
          <div className={styles.data_heading}>
            <CustomImage
              src='/images/components/CAH-Overview_Two-Thirds-Icon.svg'
              width={154}
              height={112}
              priority
              style={{ width: '100%', height: 'auto' }}
              alt=''
            />
            <div className={styles.data_heading_text}>~2/3 of patients with CAH taking GCs have <strong>poorly managed androgen levels<sup>3,5,6</sup></strong></div>
          </div>
          <p>Based on 2 large retrospective studies totaling 443 patients with CAH. Data included children and adults. “Poorly managed” was defined as elevated androgen levels and oversuppressed androgen levels.<sup>5,6</sup></p>
        </div>
        <div className={`${styles.data} ${styles.data2}`}>
          <div className={styles.data_heading}>
            <CustomImage
              src='/images/components/CAH-Overview_One-Third-Icon.svg'
              width={154}
              height={112}
              alt=''
            />
            <div className={styles.data_heading_text}>~1/3 of patients with CAH are treated for &ge;1 <strong>cardiometabolic or bone comorbidity<sup>4</sup></strong></div>
          </div>
          <p>Based on a study of 244 patients with a median age of 33 years.<sup>4</sup></p>
        </div>
        <div className={styles.aside}>
          <p>In a multicenter study, the most common comorbidities in patients with CAH taking GCs included<sup>4</sup>:</p>
          <ul>
            <li>Osteoporosis/osteopenia (59%)</li>
            <li>Hyperlipidemia (23%)</li>
            <li>Type 2 diabetes/hyperinsulinemia (22%)</li>
            <li>Hypertension (14%)</li>
          </ul>
        </div>
        <div className={styles.bottom_note}>
          <div className="hcp-callout">
            <span>Even when patients are well controlled clinically, high GC doses carry risks of long-term comorbidities. High GC doses are those that are higher than the physiologic range needed to treat adrenal insufficiency (above the physiologic range of 2-14 mg/m<sup>2</sup>/day or 5-25 mg/day in adults).<sup>1,7,8*</sup></span>
          </div>
          <ul className="footnotes">
            <li>
              <span className="hnag">*</span>
              <span>The average physiologic GC dose for adults is 7.6 mg/m<sup>2</sup>/day HCe, not just the levels used acutely for conditions such as asthma <span className="text-nowrap">(~160-200 mg/day</span> HCe in adults, typically given as 40-50 mg/day prednisolone).<sup>7,8</sup></span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}